/**
 * Users Controller
 * Defines the interface for our Users Object
 * Users are a represenation of the number of credits that our user has. When a user creates their accounts they have a balance of 0, and as the purchase/use credits, the balance changes
 */

// Import API singleton and appropriate resource interface
import api, { resolveWithStatus } from "@/services/api/api";

// Define all actions
const create = async (accessToken: string, email: string) => {
  try {
    const body = {
      email
    };

    await api.post("/users", body, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    return;
  } catch (error) {
    console.log("Failed to create user");
    console.log(error);

    throw error;
  }
};

const show = async (email: string, accessToken: string) => {
  try {
    const response = await api.get(`/users/${email}/`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    return (await resolveWithStatus(response)).data;
  } catch (error) {
    console.log("Failed to send the request");
    console.log(error);
    throw error;
  }
};

const update = async (
  body: {
    packageName: string;
    email: string;
    stripeToken: string;
  },
  accessToken: any
) => {
  try {
    const response = await api.put(`/users/${body.email}/`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    return await resolveWithStatus(response);
  } catch (error) {
    console.log("Failed to send the request");
    console.log(error);
    throw error;
  }
};

// Export all actions
export default {
  create,
  show,
  update
};
